import React, { useEffect, useRef } from 'react'
import Dropzone from 'react-dropzone'
import { useDispatch } from 'react-redux'
import { uploadFiles } from '../../../core/services/DownloadService/DownloadService.state'
import { downloadsActions } from '../../../core/services/DownloadService/DownloadService.state'
import { advertisingCampaignsActions } from '../advertisingCampaigns.state'
import { changeLocation } from 'features/routes'
import { routes } from 'features/routes'
import { getURLSearchParamsString } from '../../../features/routes/utils'

export const UploadAdvertisements = () => {
    const dropzoneRef = useRef<any>(null)
    const dispatch = useDispatch()

    useEffect(() => {
        dropzoneRef.current.open()
    }, [])

    const close = () => {
        dispatch(advertisingCampaignsActions.openAddFileModal(false))
    }

    const onDrop = (filesList: any) => {
        dispatch(advertisingCampaignsActions.setWaitingImport(true))

        dispatch(
            uploadFiles({
                filesList,
                importAdvertisement: true,
                onUploaded: (data: any) => {
                    const importedAdvertisementId = data && (data.id || data.advertisementId)

                    if (importedAdvertisementId) {
                        dispatch(advertisingCampaignsActions.setWaitingImport(false))
                        dispatch(downloadsActions.closeModal())
                        changeLocation({
                            pathname: `/${routes.editAdvertisingAds.path}`,
                            search: getURLSearchParamsString({
                                advId: importedAdvertisementId,
                            }),
                        })
                    }
                },
            })
        )

        dispatch(downloadsActions.toggleModal())
        close()
    }

    const onCancel = () => {
        dispatch(advertisingCampaignsActions.setWaitingImport(false))
        close()
    }

    return (
        <div>
            <Dropzone
                ref={dropzoneRef}
                onDrop={onDrop}
                accept={{ 'application/zip': ['.zip'] }}
                onFileDialogCancel={onCancel}
            >
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                    </div>
                )}
            </Dropzone>
        </div>
    )
}
